import { ComponentType, PropsWithChildren } from "react";

import { ProgressIndicator } from "@com.mgmtp.a12.widgets/widgets-core/lib/progress-indicator";

interface CustomProgressIndicatorProps extends PropsWithChildren {
	readonly hide?: boolean;
	readonly global?: boolean;
}

export const CustomProgressIndicator: ComponentType<CustomProgressIndicatorProps> = function CustomProgressIndicator(
	props
) {
	return (
		<>
			{props.children}
			{!props.hide && <ProgressIndicator global={props.global} fastAppear />}
		</>
	);
};
